export default class GeolocationService {
  constructor() {
  }

  async getLatLonFromAddress(address) {
    const loader = new google.maps.plugins.loader.Loader({
      apiKey: 'AIzaSyB_-JON1px4G3i047DSm_A3YX6DJzGlXpY',
      libraries: ['places'],
    });
    // make sure google maps is loaded.
    await loader.load();
    const geocoder = new google.maps.Geocoder();
    return (
      await geocoder.geocode({
        address,
      })
    ).results[0].geometry.location;
  }

  convertKilometersToMiles(km) {
    return km / 1.609;
  }

  getLatLngObjectFromString(latLngString) {
    return {
      lat: this.getLatNumberFromString(latLngString),
      lng: this.getLngNumberFromString(latLngString),
    }
  }

  getLatNumberFromString(latLngString) {
    const latString = latLngString.split(', ')[0];
    return parseFloat(latString);
  }

  getLngNumberFromString(latLngString) {
    const lonString = latLngString.split(', ')[1];
    return parseFloat(lonString);
  }

  getDistanceBetweenCoordinates (pointA, pointB) {
    if (pointA.lat && pointB.lat) {
      // Gets distance between two points using the Haversine formula
      let R = 3958.8; // Radius of the Earth in miles
      let rlat1 = pointA.lat * (Math.PI/180); // Convert degrees to radians
      let rlat2 = pointB.lat * (Math.PI/180); // Convert degrees to radians
      let difflat = rlat2-rlat1; // Radian difference (latitudes)
      let difflon = (pointB.lng-pointA.lng) * (Math.PI/180); // Radian difference (longitudes)

      return Math.round((2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2))))* 1e2 ) / 1e2;
    }
    return null;
  }
}
